'use es6';

import { connect } from 'react-redux';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WithUsersAndTeamsDataFetching from 'ui-asset-management-lib/utils/WithUsersAndTeamsDataFetching';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import Big from 'UIComponents/elements/Big';
import H2 from 'UIComponents/elements/headings/H2';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import { closeModal } from '../../actions/Actions';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { flattenTeams } from 'FileManagerCore/utils/teams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerDashboard.partitionFolderModalView.${suffix}`;
const TeamsList = ({
  assetTeams,
  teams
}) => assetTeams.isEmpty() ? /*#__PURE__*/_jsx(Big, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: getI18nKey('all')
  })
}) : /*#__PURE__*/_jsx(UIList, {
  children: assetTeams.map(id => {
    if (!teams.get(id)) {
      return null;
    }
    return flattenTeams(teams.get(id).toJS()).flat().filter(team => assetTeams.includes(team.id)).map(team => team.name).filter((teamName, index, arr) => arr.indexOf(teamName) === index);
  })
});
const ReadOnlyAccessPanel = ({
  object,
  teams,
  requestsLoading,
  dispatch
}) => /*#__PURE__*/_jsxs(UIPanel, {
  "data-test-id": "read-only-access-panel",
  children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
    onClick: () => dispatch(closeModal())
  }), /*#__PURE__*/_jsx(UIPanelHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey('title')
      })
    })
  }), /*#__PURE__*/_jsx(UIPanelBody, {
    className: "p-all-4",
    children: requestsLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('tooltip')
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('header')
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(TeamsList, {
          assetTeams: object.get('teams'),
          teams: Immutable.Map(teams.map(team => [team.id, Immutable.fromJS(team)]))
        })
      })]
    })
  })]
});
export default connect()(WithUsersAndTeamsDataFetching(ReadOnlyAccessPanel));